import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { SharedService } from '../../../shared/services/shared.service';
import { BankAccountModel } from './bankaccount.model';
import { BankAccountFormComponent } from './bankaccount-form.component';

@Component({
    selector: 'convfact-dialog-import-account-bankaccount',
    templateUrl: './bankaccount-dialog-importAccount.component.html',
    styleUrls: ['./bankaccount.component.css'],
    standalone: false
})
export class BankAccountDialogImportAccount {

    dataImport: BankAccountModel = this.data.dataImport;

    constructor(
        public dialogRef: MatDialogRef<BankAccountFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public sharedService: SharedService
    ) { }

    startImport() {
        this.sharedService.importAccountsUpdate(this.dataImport, "BankAccount").then(result => {
            this.dialogRef.close(); 
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }




}
